module.exports = __webpack_public_path__ + "static/media/unidad_medica.eaa2d882.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/unidad_medica.jpg
// module id = 65
// module chunks = 0